import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
 
Alpine.plugin(collapse)
Alpine.plugin(focus)

import "./alpine/store-auth";
import "./alpine/store-cart";

window.Alpine = Alpine;
window.Alpine.start();
